export const getCityName = (latitude: number, longitude: number) => {
  const url = ` https://geocode.maps.co/reverse?lat=${latitude}&lon=${longitude}`;

  const response = fetch(url)
    .then((response) => response.json())
    .then((data) => data)
    .catch((error) => console.error(error));

  return response;
};
